import { graphql } from "@/gql";

export const BIVY_STICKS_QUERY = graphql(`
  query bivysticks {
    bivySticks {
      edges {
        node {
          id
          imei
          batteryLevel
          organization {
            id
            name
          }
          isLocationEnabled
          isActive
          isRegistered
          isMessagesEnabled
          member {
            id
            user {
              id
            }
          }
        }
      }
    }
  }
`);
